import { INSTRUCTORS } from "@/data/content";
import { PageHero, Reveal } from "@/components/site/ui";

export default function Instructors() {
  return (
    <div data-testid="instructors-page">
      <PageHero eyebrow="Our Mentors" title="Women who teach" highlight="from experience" text="Every Ilmora mentor works in the field she teaches, and every one of them started as a beginner too." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {INSTRUCTORS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.1}>
            <div data-testid={`instructor-card-${i}`} className="glass neon-card rounded-3xl p-5 h-full">
              <img src={t.image} alt={t.name} className="w-full h-72 object-cover rounded-2xl" />
              <div className="flex items-center justify-between mt-5">
                <h3 className="font-display text-xl font-semibold">{t.name}</h3>
                <span className="text-xs rounded-full px-3 py-1 glass text-[var(--gold)] font-bold">{t.exp}</span>
              </div>
              <p className="text-sm text-[var(--pink)] font-semibold">{t.role}</p>
              <p className="text-sm text-[var(--muted)] mt-3 leading-relaxed">{t.bio}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
